module.exports = __webpack_public_path__ + "media/images/placeholder-interview-261b1a32.png";